/**
 * Seçilen grupta hiç madde olmadığında gösterilen empty state.
 */
function GroupEmptyState() {
  return (
    <div
      style={{
        height: '200px',
        border: '2px dashed #d9d9d9',
        borderRadius: '6px',
        color: '#8c8c8c',
      }}
      className="gx-w-100 gx-align-items-center gx-justify-content-center gx-d-flex"
    >
      Bu grupta henüz madde bulunmamaktadır.
    </div>
  );
}

export default GroupEmptyState;
